var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"designer-subsection"},[_c('header',[_c('div',{staticClass:"wrapper"},[_c('span',{staticClass:"index"},[_vm._v("\n        "+_vm._s(_vm.getIndex)+"\n      ")]),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("\n        "+_vm._s(_vm.label)+"\n      ")])])]),_vm._v(" "),_c('main',[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-260b2070","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/designer/_shared/designer-subsection.vue
// module id = null
// module chunks = 